import React, { useState, useEffect } from "react";
import BreadCrumb from "../../BreadCrumb";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from 'react-router';
import PageLoader from "../../../common/Loader";
import DataTable from "../../Tables/DataTable";
import SweetAlert from 'react-bootstrap-sweetalert';
import { getPaymentDueListAction, resetPaymentDueAction, resetStudentDataAction, SET_PAYMENT_DUE_LIST, studentProfileDetailsAction} from "../../../redux/actions/studentActions";
import PayModal from './payModal';
import InfiniteScroll from "react-infinite-scroll-component";
import { SMS_TYPE, STUDENT_FEE } from "../../constants";
import { createNotificationAction } from "../../../redux/actions/notificationAction";
import { getReqValue } from "../../../common/constants";
import DynamicFilters from "../../DynamicFilters";
import { Badge, Button } from "react-bootstrap";
import { downloadPaymentDueReportAction } from "../../../redux/actions/paymentAction";
import AgGridTable from "../../Tables/agGridTable";

const PaymentDue = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const StudentFeeId = params.id;
  const { loader, pagination, totalCount, paymentDueList} = useSelector(
    (state) => state.student
  );
  const { studentProfileDetails  } = useSelector((state) => state.student);
  console.log(studentProfileDetails)
  const [show, setShow] = useState(false);
  const [paymentDetailsData, setPaymentDetailsData] = useState({});
  const [filterLoader, setFilterLoader] = useState(false);
  const [branch, setBranch] = useState([]);
  const [classGroup, setClassGroup] = useState([]);
  const [classRoom, setClassRoom] = useState([]);
  const [year, setYear] = useState([]);
  const [notifyPaymentShow, setNotifyPaymentShow] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [sideMenu, setSideMenu] = useState(true);
  const [agGridRef, setAgGridRef] = useState(null);
  const [rowNode, setRowNode] = useState(null);
  const [payForDressShow, setPayForDressShow] = useState(false);

  useEffect(() => {
    dispatch(resetPaymentDueAction());
    if(StudentFeeId){
      async function getStudentProfileDetails(){
        await dispatch(resetStudentDataAction())
        await dispatch(getPaymentDueListAction({
          StudentFeeId,
          isStudentFeeLevelPaymentDue:true,
          page: 1
        }))
      }
       getStudentProfileDetails();
      
    }
  }, [])
  
  // useEffect(async() => {
  //   if(StudentId){
  //     console.log(studentProfileDetails)
  //     if(Object.keys(studentProfileDetails).length > 0 ){
  //       await dispatch(resetPaymentDueAction());
  //       await dispatch(getPaymentDueListAction({
  //           StudentId,
  //           year:studentProfileDetails.year,
  //           StudentFeeId: studentProfileDetails.StudentFeeId,
  //           page: 1
  //         }))
  //     }
  //   }
    
  // }, [studentProfileDetails])
  
  
  const onSideMenu = (value) => {
    setSideMenu(value);
  };

  const formatOptions = (listArray) => {
    return listArray.map((ele) => {
      return { value: ele, label: ele };
    });
  };
  
  const deleteAction = async (data) => {};
  const notifyAction = (data) => { 
    setPaymentDetailsData(data);
    setNotifyPaymentShow(true)
  };
  const payAction = async (data) => { 
    console.log(data)
    // data.totalFee = data.dueAmount
    // data.courseFee = data.dueAmount
    setPaymentDetailsData(data);
    setPayForDressShow(true);
    setShow(!show)
  };

  const headerList = [
    {
      name: "Enrollment No",
      key: "RegNo",
    },
    {
      name: "Name",
      key: "name",
    },
    // { name: "Gender", key: "gender" },
    { name: "Email", key: "email" },
    { name: "Total Amount", key: "totalAmount" },
    { name: "Other Fee", key: "otherFee" },
    { name: "Due Amount", key: "dueAmount" },
    {
      name: "Guardians", key: "Guardians", requiredActions: [
        {
          name: "Father",
          dataKey: "father_name",
        }, {
          name: "Father",
          dataKey: "father_phone"
        },
        {
          name: "Mother",
          dataKey: "mother_name",
        }, {
          name: "Mother",
          dataKey: "mother_phone"
        }
      ]
    },
    { name: "Class Group", key: "ClassGroupName" },
    { name: "Class Room", key: "section" },
    {
      name: "Action",
      key: "action",
      requiredActions: [
        {
          actionKey: "Notify Payment",
          icon: "fa fa-bell",
          handleAction: notifyAction,
        },
        {
          actionKey: "Pay Due",
          icon: "fa fa-money",
          handleAction: payAction,
        },
      ],
    },

  ];

  const actionsListComponent = props => {
    console.log(props)
    return (
      <>
          {
            props.data ? (
              <>
              <span>
            <i class={"fa fa-bell" + (props.data.isPreviousHistory ?  ' fa-disabled': ''  )}  aria-hidden="true" title="Notify Student" style={{
          alignItems: "center",
          color: "#1c5983",
          cursor: 'pointer',
          fontSize:"18px"
          
        }} onClick={()=>{
          props.notifyAction(props.data);
        }}></i> &nbsp;&nbsp;&nbsp;
         <i class={"fa fa-money" + (props.data.isPreviousHistory ?  ' fa-disabled': ''  ) } aria-hidden="true" title="Pay For" style={{
          alignItems: "center",
          cursor: 'pointer',
          color: "#1c5983",
          fontSize:"18px"
        }} onClick={()=>{
          props.payAction(props.data);
        }} ></i>
          </span>
              </>
            ): null 

          }
      </>
    )  
  };

  const columnDefs = [
    {
      headerName: "Reg No",
      field: "RegNo",
      filter:true,floatingFilter:true,sortable: true,
      // cellClass:"vertical-middle",
    },
    {
      headerName: "Name",
      field: "name",
      filter:true,floatingFilter:true,sortable: true,
    },
    // {
    //   headerName: "Email",
    //   field: "email",
    //   filter:true,floatingFilter:true,sortable: true,
    // },
    {
      headerName: "Mother Phone Number",
      field: "phoneNumber",
    },
    // {
    //   headerName: "Father Phone Number",
    //   field: "father_phone",
    // },
    
    { headerName: "Class Group", field: "ClassGroupName",maxWidth:150,
  },
    { headerName: "Class Room", field: "classRoomName" ,maxWidth:150},

  { headerName: "Fee", field: "totalAmount",maxWidth:100 },

  { headerName: "Other Fee", field: "otherFee",maxWidth:150 },
  { headerName: "Total Due Amount", field: "dueAmount",maxWidth:200 },
    {
      headerName: "Action",
      field: "action",
      maxWidth: 150,
      cellRenderer: "actionsListComponent",
      cellRendererParams: {
        notifyAction,
        payAction,
        agGridRef
      },
      
    },
  ];

  const nestedHeaders = ['','', '', '','', 'Name', 'Phone Number ', 'Name', 'Phone Number', '','','','']
  
const notifyStudent =async()=>{
  await dispatch(createNotificationAction({
    notifiableType: STUDENT_FEE,
    StudentFeeId: paymentDetailsData.StudentFeeId,
    StudentId: paymentDetailsData.StudentId,
    BranchId: paymentDetailsData.BranchId,
    ClassGroupId: paymentDetailsData.ClassGroupId,
    ClassRoomId: paymentDetailsData.ClassRoomId,
    name : paymentDetailsData.name,
    notificationType: SMS_TYPE
  }))
  setNotifyPaymentShow(false);
}
const onCancel = ()=>{
  setNotifyPaymentShow(false);
}
const DynamicFiltersProps = [
  {
    type: "Select",
    placeholder: "Select Year",
    state: year,
    mappingKey: "year",
    // onMenuCloseApi: true,
    grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    label: "Year",
  },
  {
    type: "Select",
    placeholder: "Select Branch",
    state: branch,
    mappingKey: "branch",
    onMenuCloseApi: true,
    grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    label: "Branch",
  },
  {
    type: "Select",
    placeholder: "Select ClassGroup",
    state: classGroup,
    mappingKey: "classGroup",
    onMenuCloseApi: true,
    grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    label: "Class Group",
  },
  {
    type: "Select",
    placeholder: "Select ClassRoom",
    state: classRoom,
    mappingKey: "classRoom",
    // onMenuCloseApi: true,
    grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    label: "ClassRoom",
  },
  
];

const DynamicFiltersOptions = {
  branchOptions: [],
  classGroupOptions: [],
  classRoomOptions: [],
  yearOptions: [],
};

const hierarchyLevel = ["branch", "classGroup", "classRoom"];
const hierarchyApiCalls = [
  {
    optionsMappingKey: "branch",
    UrlName: "branch",
  },
  {
    optionsMappingKey: "year",
    UrlName: "year",
  },
];
const hierarchyFilterApi = "branchFilter";
const onRefresh = () => {
  reloadData();
};
const reloadData = () => {
  setBranch([]);
  setClassGroup([]);
  setClassRoom([]);
  setYear([]);
  dispatch(resetPaymentDueAction())
};
const updateState = (params) => {
  let keysLength = Object.keys(params).length;
  if (params.hasOwnProperty("branch")) {
    setBranch(params[`branch`]);
  }
  if (params.hasOwnProperty("classGroup")) {
    setClassGroup(params[`classGroup`]);
  }
  if (params.hasOwnProperty("classRoom")) {
    setClassRoom(params[`classRoom`]);
  }
  if (params.hasOwnProperty("year")) {
    setYear(params[`year`]);
  }
};
const fetchParamsList = async()=>{
  const params = {
    BranchId: getReqValue(branch),
    ClassGroupId: getReqValue(classGroup),
    ClassRoomId: getReqValue(classRoom),
    year: getReqValue(year),
    // page: (pagination.currentPage + 1),
    perPage: pagination.perPage
  };
  return params;
}
const fetchPaymentList = async (params) => {
  await dispatch(getPaymentDueListAction(params));
};

const filterData = async () => {
  await dispatch(resetPaymentDueAction())
  let reqParams = await fetchParamsList();
    reqParams.page = 1;
  await fetchPaymentList(reqParams);
};
const openLoader = () => {
  setFilterLoader(true);
};
const closeLoader = () => {
  setFilterLoader(false);
};
const downloadPaymentReports = async() => {
  const params = {
    BranchId: getReqValue(branch),
    ClassGroupId: getReqValue(classGroup),
    ClassRoomId: getReqValue(classRoom),
    year: getReqValue(year)
  };
  await dispatch(downloadPaymentDueReportAction(params))

}
const fetchMoreData =async()=>{
  console.log(pagination)
  if ((pagination.totalPages === 1 || (pagination.totalPages -1) === pagination.currentPage)  ) {
    setHasMore(false)
    return;
  }
  let reqParams = await fetchParamsList();
    reqParams.page = ( pagination.currentPage + 1);
  await fetchPaymentList(reqParams)
}
const setGridRefData =(params)=>{
  setAgGridRef(params)
}

  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader || filterLoader}>
        <div
          className={`main-content d-flex flex-column ${sideMenu ? "" : "hide-sidemenu"
            }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          {notifyPaymentShow ? (
               <SweetAlert
               warning
               showCancel
               confirmBtnText="Send"
               confirmBtnBsStyle="info"
               title="Are you sure?"
               onConfirm={notifyStudent}
               onCancel={onCancel}
               focusCancelBtn
             >
               Are you sure you want to send payment due Notification.
             </SweetAlert>
   
          ): null }
         
          {/* <h4>Students List</h4> */}
          <PayModal show={show} data={paymentDetailsData}
                          payForDressShow={payForDressShow}
                          setPayForDressShow={setPayForDressShow}
          />
         { StudentFeeId ? null : (
           <>
           <div class="row filter-block">
            <DynamicFilters
              filtersList={DynamicFiltersProps}
              options={DynamicFiltersOptions}
              hierarchyLevel={hierarchyLevel}
              hierarchyApiCalls={hierarchyApiCalls}
              hierarchyFilterApi={hierarchyFilterApi}
              openLoader={openLoader}
              closeLoader={closeLoader}
              updateParentState={updateState}
              filterData={filterData}
              onReset={onRefresh}
              // onDatepickerChange={this.handleYearData}
              viewType="verticle"
              isFilterButtonDisabled={branch.length === 0 || year.length === 0}
            />
          </div>
          <div className="row">
            <div className="col-2">
                  <Button
                      className="btn  app-default-button btn-sm"
                    >
                      Payment Due Students <Badge variant="primary">{pagination.totalItems}</Badge>
                    </Button>
                    
                  </div>
                  <div className="col-8">
                  </div>
                <div className="col-2 text-right">
                <Button
                      className="btn  app-default-button btn-sm"
                      disabled={paymentDueList.length === 0}
                      onClick={downloadPaymentReports}
                    >
                      <i className="fa fa-download"></i>
                    </Button>
                  </div>
            </div>
           </>
         )} 
          <div className="spacer"> </div>
          <div>
          {paymentDueList.length > 0 ? (
            <>
            {/* <InfiniteScroll
             dataLength={paymentDueList.length}
             next={fetchMoreData}
             hasMore={pagination.totalPages === 1 ? false : hasMore}
             loader={<h4>Loading...</h4>}
             endMessage={
               <div className="alert alert-success text-center">
                 Yay! You have seen it all
               </div>
             }
           >
             <DataTable header={headerList} data={paymentDueList} nestedHeader={nestedHeaders} />
           </InfiniteScroll> */}
           <AgGridTable 
            rowData={paymentDueList} 
            columnDefs={columnDefs} 
            defaultColDef={{
              resizable: true,minWidth: 100}}
            frameworkComponents={{
                actionsListComponent
            }}
            pagination={pagination}
            // datasource={datasource}
            isPaginationRequired={true}
            actionType={SET_PAYMENT_DUE_LIST}
            fetchParamsList={fetchParamsList}
            setAgGridRef={setGridRefData}
              />
            </>
          ) : <div className="alert alert-success">
            No Data to view
          </div>}
            </div>

        </div>
      </PageLoader>
    </div>
  );
};

export default PaymentDue;

